import React from 'react';
import './Typed.css';
// import { NavLink } from 'react-router-dom'
var ReactRotatingText = require('react-rotating-text');
const Type = () => {
    return(
        <React.Fragment>
            
            <div className="home-first">
                <div className="flex-wrap">
                    <div className="left">
                        <h2>Hello<span>🤓</span></h2>
                        <h2>নমস্কার</h2>
                        <h1>I am Soham Das<span>🙂</span></h1>
                        <h1>I am <ReactRotatingText className="text-rotate" color={'red'} items={['a Student', 'a Learner','a Programmer', 'a Web Developer', 'a Tech Lover']} /></h1>
                    </div>
                    <div className="right">
                        <img className="hi" src="assets/hi.gif" alt="hi"/>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}
export default Type;